import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";

type ResourceValue = string | readonly string[] | Readonly<Record<string, string>>;

export function defineResources<T extends Record<string, ResourceValue>>(resources: {
  [LanguageEnum.CS]: T;
  [LanguageEnum.EN]: {
    [K in keyof T]: T[K] extends readonly string[]
      ? readonly string[]
      : T[K] extends string
        ? string
        : T[K];
  };
}): { [L in LanguageEnum]: T } {
  return resources as { [L in LanguageEnum]: T };
}
